import { LoadingService } from '../services/loading.service';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, finalize, switchMap, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { AuthenticationService } from '../../features/authentication/services/authentication.service';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { LoginResponseDto } from '../../features/authentication/dtos/login-response.dto';
import { MemoryService } from '../services/memory.service';
import { RefreshTokenDto } from '../../features/authentication/dtos/refresh-token.dto';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);
  const memoryService = inject(MemoryService);
  const loadingService = inject(LoadingService);
  const storageService = inject(StorageService);

  loadingService.setLoading(true, req.url);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 401:
          if (req.url.endsWith('/login')) {
            return throwError(() => error);
          }

          let refreshToken = storageService.loadRefreshToken();
          if (refreshToken == null || req.url.endsWith('/refresh-token')) {
            router.navigate(['/login']);

            let handledError: any = error;
            handledError.isAuthHandled = true;
            return throwError(() => handledError);
          }

          let refreshTokenDto: RefreshTokenDto = { refreshToken: refreshToken };
          return authenticationService.refresh(refreshTokenDto).pipe(
            switchMap((loginResponseDto: LoginResponseDto) => {
              storageService.storeRefreshToken(loginResponseDto.refreshToken);
              memoryService.accessToken = loginResponseDto.accessToken;

              const accessTokenRequest = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${memoryService.accessToken}`
                }
              });

              return next(accessTokenRequest);
            }),
            catchError((_) => {
              router.navigate(['/login']);

              let handledError: any = error;
              handledError.isAuthHandled = true;
              return throwError(() => handledError);
            })
          );

        default:
          return throwError(() => error);
      }
    }),
    finalize(() => {
      loadingService.setLoading(false, req.url);
    }),
  );
};
